import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import AssetInfoCard from './AssetInfoCard';

import { CertificateSubmission } from '../../model';

interface SpecifxInfoForExistingAssetsSectionProps {
  submission: CertificateSubmission;
}

const SpecifxInfoForExistingAssetsSection: React.FC<SpecifxInfoForExistingAssetsSectionProps> = (props) => {
  const { submission } = props;

  return (
    <Grid container spacing={2} style={{ padding: '1% 2%' }}>
      <Typography variant="h5" style={{ marginTop: 15 }}>
        Specifx Info for Existing Assets
      </Typography>
      {submission.assets?.length > 0 ? (
        <Grid container spacing={2}>
          {submission.assets?.map((asset) => (
            <Grid item xs={12} key={`asset-${asset.id}`}>
              <AssetInfoCard asset={asset} certificateSubmissionId={submission.id} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 120 }}>
          <Grid item>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{
                textAlign: 'center',
                fontStyle: 'italic',
                opacity: 0.7,
              }}
            >
              No previously-existing assets have been added to this submission yet
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default SpecifxInfoForExistingAssetsSection;
